import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'

import Page from '../../components/layout/Page'
import Container from '../../components/layout/Container'
import FullSizeSection from '../../components/layout/FullSizeSection'
import { ApplicationState, ConnectedReduxProps } from '../../store'
import { Images } from '../../store/images/types'
import { fetchRequest } from '../../store/images/actions'
import { bulkUpdate } from '../../store/images/actions'

import Slider from "react-slick";
import SliderArrow from '../../components/layout/SliderArrow'
import styled, { Theme } from '../../utils/styled'
import Loadingbar from '../../components/layout/Loaderbar'
import { darken } from 'polished'
import { Themed } from 'react-emotion'
import { Dispatch } from 'redux'

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
  loading: boolean
  data: Images[]
  errors?: string
}

interface FullSizeGalleryProps {
  galleryid?: number
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  bulkUpdate: typeof bulkUpdate
}

interface State {
  selected?: Images
}
// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & FullSizeGalleryProps & ConnectedReduxProps

class FullSizeGallery extends React.Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props)
    this.state = {
      selected: undefined
    }
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.galleryid !== nextProps.galleryid) // Check if it's a new user, you can also use some unique property, like the ID
    {
      this.props.fetchRequest(this.props.galleryid)
    }
}
  public componentDidMount() {
    const { data } = this.props
      if (this.props.galleryid>0) {
        this.props.fetchRequest(this.props.galleryid)
    }
  }

  public render() {
    const { data, loading } = this.props
    const settings = {
      dots: true,
      infinite: true,
      prevArrow: <SliderArrow to="prev" faIcon="arrow-left" />,
      nextArrow: <SliderArrow to="next" faIcon="arrow-right" />,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <div>
        {loading && <Loadingbar />}
        {!loading && data.length>=0 && (
        <Slider {...settings}>
        { data.map((item, index) => (<GalleryItem key={index}><GalleryImage src={item.location} /></GalleryItem>) }
        </Slider>)}
      </div>
    )
  }
}
const mapStateToProps = ({ images }: ApplicationState) => ({
  loading: images.loading,
  errors: images.errors,
  data: images.data
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRequest: id => dispatch(fetchRequest(id)),
  bulkUpdate: id => dispatch(bulkUpdate(id))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FullSizeGallery)

const GalleryItem = styled('div')`
    width: 100vw;
    height: 100vh;
    position: relative;
    text-align: center;
`
const GalleryImage = styled('img')`
    /* width: 100vw; */
    /* height: 100vh; */
    text-align: center;
    transform: translate(-50%,-50%);
     top: 50%;
    left: 50%;
    position:absolute;
`
